// Dedicated axios instance for the client-facing portal.
// Same origin as the admin app but uses a separate HttpOnly cookie (`portal_session`).
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PORTAL_API = `${BACKEND_URL}/api/portal`;

const portalApi = axios.create({ baseURL: PORTAL_API, withCredentials: true });

export const fmtINR = (n) =>
    "₹ " + Number(n || 0).toLocaleString("en-IN",
        { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtQty = (n) =>
    Number(n || 0).toLocaleString("en-IN",
        { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export default portalApi;
